import { Reveal, Overline } from "./Reveal";
import { CONTACT } from "./data";
import { Mail, Phone } from "lucide-react";

export const BookingCTA = () => (
  <section
    id="enquire"
    data-testid="enquire-section"
    className="relative py-28 md:py-44 border-t border-line/40 overflow-hidden"
  >
    <div className="absolute inset-0 placeholder-grid opacity-40 pointer-events-none" />
    <div className="relative max-w-4xl mx-auto px-6 md:px-12 text-center">
      <Reveal>
        <Overline>Enquire & book direct</Overline>
        <h2 className="font-serif font-light tracking-tight leading-[0.95] text-textMain text-4xl md:text-6xl lg:text-7xl mt-8">
          Arrive as guests.<br />Leave as friends.
        </h2>
        <p className="font-sans text-textMuted leading-relaxed mt-8 max-w-xl mx-auto">
          Whether you're celebrating a special occasion, escaping for a romantic break or exploring everything Wiltshire has to offer — get in touch and we'll help plan your stay.
        </p>
      </Reveal>

      <Reveal delay={0.15} className="mt-12 flex flex-col sm:flex-row items-stretch justify-center gap-4 md:gap-5">
        {CONTACT.email ? (
          <a
            href={`mailto:${CONTACT.email}`}
            data-testid="enquire-email"
            className="group flex items-center justify-center gap-3 rounded-xl border border-line hover:border-primary px-8 py-5 transition-colors duration-300"
          >
            <Mail className="w-5 h-5 text-primary" strokeWidth={1.5} />
            <span className="font-sans text-base text-textMain group-hover:text-primary transition-colors">{CONTACT.email}</span>
          </a>
        ) : (
          <div data-testid="enquire-email" className="flex items-center justify-center gap-3 rounded-xl border border-dashed border-line/70 px-8 py-5">
            <Mail className="w-5 h-5 text-primary/60" strokeWidth={1.5} />
            <span className="font-mono text-xs uppercase tracking-[0.2em] text-textMuted">Email — coming soon</span>
          </div>
        )}

        {CONTACT.phone ? (
          <a
            href={`tel:${CONTACT.phone.replace(/\s/g, "")}`}
            data-testid="enquire-phone"
            className="group flex items-center justify-center gap-3 rounded-xl border border-line hover:border-primary px-8 py-5 transition-colors duration-300"
          >
            <Phone className="w-5 h-5 text-primary" strokeWidth={1.5} />
            <span className="font-sans text-base text-textMain group-hover:text-primary transition-colors">{CONTACT.phone}</span>
          </a>
        ) : (
          <div data-testid="enquire-phone" className="flex items-center justify-center gap-3 rounded-xl border border-dashed border-line/70 px-8 py-5">
            <Phone className="w-5 h-5 text-primary/60" strokeWidth={1.5} />
            <span className="font-mono text-xs uppercase tracking-[0.2em] text-textMuted">Phone — coming soon</span>
          </div>
        )}
      </Reveal>

      <Reveal delay={0.25}>
        <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-textMuted mt-10">
          Self check-in · Complete flexibility · Up to 2 guests
        </p>
      </Reveal>
    </div>
  </section>
);
